import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import MUIDataTable from "mui-datatables"
import { useSnackbar } from 'notistack'
import CheckBox from '../../components/Form/Checkbox'
import { useAuth } from '../../hooks/auth'
import alert from '../../pages/Concierge/Manage/images/alert.gif'
import MvmApi from '../../services/MvmApi'
import utilsDate from '../../utils/Date'
import { useStyles } from './Style'
import { FIASA_PLANT_ID, MOPAR_PLANT_ID } from '../../utils/constants'

type Props = {
    reloadOnCLick?: any;
    getCounts?: any;
}

const EntryPlant: React.FC<Props> = (props) => {
    const classes = useStyles();
    const { t } = useTranslation("EntryPlant");
    const { t: tGeneral } = useTranslation("General")
    const { t: tValidation } = useTranslation("Validation")
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [mvmId, setMvmId] = React.useState(0);
    const [errorDock, setErrorDock] = React.useState(false)
    const [selectedDock, setSelectedDock] = React.useState('')
    const { user } = useAuth();
    const { enqueueSnackbar } = useSnackbar();
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [isOnlyXDResponsible, setIsOnlyXDResponsible] = React.useState(false)
    const [isXDResponsible, setIsXDResponsible] = React.useState(false);
    const { isLoading, isFetching, data, refetch } = useQuery('entryAuthorizationMvmMonitor', async () => {
        props.getCounts();
        var itens = await MvmApi.getEntryAuthorizationMvm(+user.company.plantID, user.userName);

        if (itens[0] !== undefined) {
            setIsXDResponsible(itens[0].isXDResponsible == 'S');
            setIsOnlyXDResponsible(itens[0].isOnlyXDResponsible == 'S');
        }

        return itens;
    }, {
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: true,
        staleTime: 1000 * 360, //calculado em milisegundos - Propriedade para setar qto tempo o cache fica válido
        refetchInterval: 1000 * 1200, //calculado em milisegundos - Propriedade para setar qto tempo vai buscar o cache novamente
    });

    useEffect(() => {
        refetch();
    }, []);

    useEffect(() => {
        if (props.reloadOnCLick > 0) {
            refetch();
        }
    }, [props.reloadOnCLick]);

    const handleConfirmation = async (IsXDAuthorized: boolean) => {
        // Apenas MOPPAR
        if (+user.company.plantID === 4 && (selectedDock == null || selectedDock === '')) {
            setErrorDock(true);
            return;
        }

        setDialogOpen(false);
        setOpenBackdrop(true);
        MvmApi.autoryzePlantEntry({ MvmId: mvmId, dock: selectedDock, IsXDAuthorized: IsXDAuthorized })
            .then(result => async () => {
                enqueueSnackbar(t("autorizedEntryPlantSuccess"), { variant: 'success' });
            }).finally(() => {
                setOpenBackdrop(false);
                props.getCounts();
                resetFormAuthorizeEntry()
                refetch();
            });

    };

    const handleDialogClickOpen = (idMvm: number) => {
        setMvmId(idMvm);
        setDialogOpen(true);
    };

    const handleDialogClickClose = () => {
        resetFormAuthorizeEntry()
        setDialogOpen(false);
    };

    const columns = [
        {
            name: 'isAutorized',
            options: {
                display: false
            }
        },
        {
            name: 'isXDResponsible',
            options: {
                display: false
            }
        },
        {
            name: 'isOnlyXDResponsible',
            options: {
                display: false
            }
        },
        {
            style: { width: 80 },
            name: 'mvmId',
            label: ' ',
            innerWidth: 10,
            options: {
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (tableMeta.rowData[0] == 'False') {
                        return (

                            <Button
                                variant="outlined"
                                style={{ height: "100%", width: "90%", fontSize: "0.7rem", padding: "2px" }}
                                onClick={() => handleDialogClickOpen(value)}>
                                {t("autorizeEntryPlant")}
                            </Button>
                        );
                    }
                    else {
                        return <div style={{ minWidth: 80 }}>{""}</div>;
                    }
                }
            },
        },
        {
            name: 'shedCode',
            label: t("shedCode"),
        },
        {
            name: 'mvmCode',
            label: t("mvmCode"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }

        },
        {
            name: 'vehiclePlateNumber',
            label: t("vehiclePlateNumber"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'vehicleType',
            label: t("vehicleType"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'supplierDescription',
            label: t("supplierDescription"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'deliveryWindowTime',
            label: t("deliveryWindowTime"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return <span>{utilsDate.DateTime(value)}</span>
                }
            }

        },
        {
            name: 'presentationTime',
            label: t("presentationTime"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return <span>{utilsDate.DateTime(value)}</span>
                }
            }
        },
        {
            name: 'windowStatus',
            label: t("windowStatus"),

            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: (cellValue: string, rowIndex: number, columnIndex: number) => ({
                    align: "center",
                    style: {
                        backgroundColor: data![rowIndex].flagWindowStatus != 'WHITE' ? data![rowIndex].flagWindowStatus : '',
                        color: data![rowIndex].flagWindowStatus != "YELLOW" && data![rowIndex].flagWindowStatus != "WHITE" ? "white" : "black"
                    }

                })
            }
        },
        {
            name: 'isThereCriticalMaterial',
            label: t("isThereCriticalMaterial"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <Box display='flex' alignItems='center' justifyContent='center'>
                            {value == 'S' ?
                                (
                                    <>
                                        <img src={alert} title="Alerta" height={24} width={24} style={{ marginRight: 5, }} /> Sim
                                    </>
                                ) :
                                'Não'}
                        </Box>
                    );
                }
            }
        },
    ]

    const options = {
        textLabels: {
            body: {
                noMatch: tGeneral('noMatch'),
                toolTip: "",
            },
            pagination: {
                next: tGeneral("next"),
                previous: tGeneral("previous"),
                rowsPerPage: tGeneral("rowsPerPage") + ":",
                displayRows: tGeneral("of"),
            }
        }
    }

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 10,
                    paddingTop: 10
                },
                head: {
                    height: 52
                }
            }
        }
    })

    interface IFormInput {
        selectDock: any;
        D1A: any;
        D1B: any;
        D2A: any;
        D2B: any;
        D3B: any;
        D4A: any;
        D4B: any;
        D5A: any;
        D5B: any;
        D6A: any;
        PATIO: any;
    }

    const { control, reset, setValue } = useForm<IFormInput>(
        {
            defaultValues: {
                D1A: false,
                D1B: false,
                D2A: false,
                D2B: false,
                D3B: false,
                D4A: false,
                D4B: false,
                D5A: false,
                D5B: false,
                D6A: false,
                PATIO: false
            }
        })

    const resetFormAuthorizeEntry = () => {
        reset()
        setErrorDock(false)
        setSelectedDock('')
    }

    const valueDockChanged = (e: any) => {
        if (!e.target.checked) {
            setSelectedDock('')
            return
        }

        if (e.target.name === 'D1A')
            setSelectedDock('D.1A')
        else
            setValue('D1A', false)

        if (e.target.name === 'D1B')
            setSelectedDock('D.1B')
        else
            setValue('D1B', false)

        if (e.target.name === 'D2A')
            setSelectedDock('D.2A')
        else
            setValue('D2A', false)

        if (e.target.name === 'D2B')
            setSelectedDock('D.2B')
        else
            setValue('D2B', false)

        if (e.target.name === 'D3B')
            setSelectedDock('D.3B')
        else
            setValue('D3B', false)

        if (e.target.name === 'D4A')
            setSelectedDock('D.4A')
        else
            setValue('D4A', false)

        if (e.target.name === 'D4B')
            setSelectedDock('D.4B')
        else
            setValue('D4B', false)

        if (e.target.name === 'D5A')
            setSelectedDock('D.5A')
        else
            setValue('D5A', false)

        if (e.target.name === 'D5B')
            setSelectedDock('D.5B')
        else
            setValue('D5B', false)

        if (e.target.name === 'D6A')
            setSelectedDock('D.6A')
        else
            setValue('D6A', false)

        if (e.target.name === 'PATIO')
            setSelectedDock('PATIO')
        else
            setValue('PATIO', false)

    }

    return (
        <>
            <Backdrop className={classes.backdrop} open={openBackdrop || isLoading || isFetching}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Dialog
                open={dialogOpen}
                onClose={handleDialogClickClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Autorização"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {"Deseja autorizar a entrada na planta?"}
                    </DialogContentText>
                    {+user.company.plantID === MOPAR_PLANT_ID &&
                        <>
                            <br />{tGeneral('selectDock')}<br />
                            <CheckBox name='D1A' label={'D.1A'} control={control} onChange={(e) => valueDockChanged(e)} style={{ paddingBottom: '0px', paddingTop: '0px' }} /><br />
                            <CheckBox name='D1B' label={'D.1B'} control={control} onChange={(e) => valueDockChanged(e)} style={{ paddingBottom: '0px', paddingTop: '0px' }} /><br />
                            <CheckBox name='D2A' label={'D.2A'} control={control} onChange={(e) => valueDockChanged(e)} style={{ paddingBottom: '0px', paddingTop: '0px' }} /><br />
                            <CheckBox name='D2B' label={'D.2B'} control={control} onChange={(e) => valueDockChanged(e)} style={{ paddingBottom: '0px', paddingTop: '0px' }} /><br />
                            <CheckBox name='D3B' label={'D.3B'} control={control} onChange={(e) => valueDockChanged(e)} style={{ paddingBottom: '0px', paddingTop: '0px' }} /><br />
                            <CheckBox name='D4A' label={'D.4A'} control={control} onChange={(e) => valueDockChanged(e)} style={{ paddingBottom: '0px', paddingTop: '0px' }} /><br />
                            <CheckBox name='D4B' label={'D.4B'} control={control} onChange={(e) => valueDockChanged(e)} style={{ paddingBottom: '0px', paddingTop: '0px' }} /><br />
                            <CheckBox name='D5A' label={'D.5A'} control={control} onChange={(e) => valueDockChanged(e)} style={{ paddingBottom: '0px', paddingTop: '0px' }} /><br />
                            <CheckBox name='D5B' label={'D.5B'} control={control} onChange={(e) => valueDockChanged(e)} style={{ paddingBottom: '0px', paddingTop: '0px' }} /><br />
                            <CheckBox name='D6A' label={'D.6A'} control={control} onChange={(e) => valueDockChanged(e)} style={{ paddingBottom: '0px', paddingTop: '0px' }} /><br />
                            <CheckBox name='PATIO' label={'PÁTIO'} control={control} onChange={(e) => valueDockChanged(e)} style={{ paddingBottom: '0px', paddingTop: '0px' }} />
                            {!errorDock || <><br /><br /><span style={{ color: 'red' }}>{tValidation('selectDockToContinue')}</span></>}
                        </>}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClickClose}>{"Cancelar"}</Button>
                    {!isOnlyXDResponsible && <Button onClick={() => handleConfirmation(false)} autoFocus>{"Autorizar"}</Button>}
                    {isXDResponsible && +user.company.plantID === FIASA_PLANT_ID && <Button onClick={() => handleConfirmation(true)} >{"Autorizar XD"}</Button>}
                </DialogActions>
            </Dialog>


            <MuiThemeProvider theme={myTheme}>
                <MUIDataTable
                    title=""
                    data={data != null && data.length > 0 ? data : []}
                    columns={columns}
                    options={{
                        ...options,
                        serverSide: true,
                        pagination: false,
                        sort: false,
                        selectToolbarPlacement: "none",
                        filter: false,
                        search: false,
                        download: false,
                        print: false,
                        viewColumns: false,
                        selectableRows: 'none',
                    }}
                />
            </MuiThemeProvider>

        </>
    )
}
export default EntryPlant;
